
<span
    [@fadeIn]>
        <ng-content></ng-content>
        <button
            *ngFor="let button of nonMenuButtons$ | async; let last = last"
            mat-icon-button
            [ngClass]="{ 'non-menu-button': !last}"
            (click)="button.method($event)"
            [disabled]="(button.isLoadingChangeCommand | async) || button.isDisabled()"
        >
            <ng-container *ngIf="button.isLoadingChangeCommand | async as isLoadingChangeCommand">
                <mat-icon [class.spinner]="isLoadingChangeCommand"></mat-icon>
            </ng-container>
            <mat-icon
                [ngClass]="{'material-icons-outlined' : button.hasOwnProperty('isIconOutlined') && button.isIconOutlined() }"
                [class.hidden]="(button.isLoadingChangeCommand | async)">
                    {{ button.icon() }}
            </mat-icon>
        </button>
        <button
            *ngIf="hasOverflowButtons$ | async"
            class="overflow-menu-button"
            mat-icon-button
            [matMenuTriggerFor]="menu"
        >
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
            <ng-template matMenuContent>
                <button
                    mat-menu-item
                    *ngFor="let button of overflowButtons$ | async"
                    (click)="button.method($event)"
                >
                    <mat-icon [ngClass]="{'material-icons-outlined' : button.hasOwnProperty('isIconOutlined') && button.isIconOutlined() }">{{button.icon()}}</mat-icon>
                    {{button.title()}}
                </button>
            </ng-template>
        </mat-menu>
</span>
